<template>
  <div class="login">
    <div class="ion">
      <!-- <vue-particles
        color="#7b7d7d"
        :particleOpacity="0.7"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="4"
        linesColor="#203c77"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="100"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="lizi"
      ></vue-particles>-->
    </div>
    <div class="form dis-flex1">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm margin"
        size="medium"
      >
        <el-form-item label="账号" prop="user">
          <el-input v-model="ruleForm.user" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">登录</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {
      loading: false,//按钮加载状态
      ruleForm: {
        user: '',
        pass: ''
      },
      rules: {
        user: [
          { validator: validatePass, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    if (localStorage.getItem('login') !== '' || localStorage.getItem('login') !== null) {
      let login = JSON.parse(localStorage.getItem('login')) || {}
      this.ruleForm = {
        user: login['user'],
        pass: login['pass']
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          let res = await this.$http.login(this.ruleForm.user, this.ruleForm.pass)
          this.loading = false
          if (res.data.status == 1) {
            await localStorage.setItem('login', JSON.stringify({ user: this.ruleForm.user, pass: this.ruleForm.pass }))
            this.$nw.big();
            this.$router.push('/index')
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style lang="less">
@import "../assets/less/view/login.less";
</style>